import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import BusinessTypeSelect from "../../../../component/global/BusinessTypeSelect";
import { ToastContext } from "../../../../component/global/ToastContext";
import { GlobalStateContext } from "../../../../layouts/GlobalStates";
import { get, patch } from "../../../../controlers/global/ConfigRequest";
import { COMPANY_DETAIL } from "../../../../helperData/ApiAddress";
import { selectedBusinessTypeIds } from "../../../profile/companyProfilePayload";

function currentCompanyId(auth) {
    return auth?.usercompany || window.sessionStorage.getItem("usercompany");
}

export default function BusinessTypeEditor({ onSaved }) {
    const { t } = useTranslation();
    const globals = useContext(GlobalStateContext);
    const auth = globals?.auth;
    const toast = useContext(ToastContext);
    const [ids, setIds] = useState([]);
    const saveTimer = useRef();
    const companyId = currentCompanyId(auth);

    useEffect(() => {
        if (!companyId) return undefined;
        get(COMPANY_DETAIL.replace("{id}", companyId))
            .then((company) => setIds(selectedBusinessTypeIds(company)))
            .catch(() => {});
        return () => clearTimeout(saveTimer.current);
    }, [companyId]);

    const persist = (next) => {
        setIds(next);
        if (!companyId) return;
        clearTimeout(saveTimer.current);
        saveTimer.current = setTimeout(() => {
            patch(COMPANY_DETAIL.replace("{id}", companyId), {
                business_types: next,
                category: next[0] || null,
            })
                .then(() => onSaved?.())
                .catch(() =>
                    toast(t("template.business.type.save.error"), "danger")
                );
        }, 400);
    };

    return (
        <section
            className="business-type-card"
            aria-labelledby="template-business-type-title"
        >
            <h2 id="template-business-type-title">
                {t("Organizational.Profile.BusinessType.label")}
            </h2>
            <p>{t("template.business.type.hint")}</p>
            <BusinessTypeSelect
                value={ids}
                onChange={persist}
                hint={t("Organizational.Profile.BusinessType.hint")}
            />
        </section>
    );
}
